import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { apiBaseUrl, apiKey } from "../../../utils/config";


export const placePendingOrder = createAsyncThunk(
    'order/placePendingOrder',
    async (orderPayload, { rejectWithValue }) => {
        try {
            let token = localStorage.getItem("token");
            const response = await axios.post(`${apiBaseUrl}/trade/order-pending`, {
                api_key: apiKey,
                account: orderPayload.account,
                symbol: orderPayload.symbol,
                volume: orderPayload.volume,
                price: "0",
                type: orderPayload.type,
                tp: orderPayload.tp ,
                sl: orderPayload.sl ,
                comment: "",
                price_trigger:orderPayload.price_trigger
            },
            {
                headers: {
                    "Trade-Account-Token": token
                }
            });

            console.log("Pending Order API raw response:", response.data);
            return response.data; 
        } catch (error) {
            console.error("Pending Order API error:", error.response?.data || error.message); 
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


const pendingOrderSlice = createSlice({
    name: 'pendingOrder',
    initialState: {
        pendingOrderStatus: 'idle',
        pendingOrderData: null,
        pendingOrderMessage: '',
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(placePendingOrder.pending, (state) => {
                state.pendingOrderStatus = 'loading';
                state.pendingOrderData = null;
                state.error = null;
            })
            .addCase(placePendingOrder.fulfilled, (state, action) => {
                state.pendingOrderStatus = 'succeeded';
                state.pendingOrderData = action.payload; 
                state.pendingOrderMessage=action.payload.message
            })
            .addCase(placePendingOrder.rejected, (state, action) => {
                state.pendingOrderStatus = 'failed';
                state.error = action.payload; 
            });
    }
});


export default pendingOrderSlice.reducer;
